module.exports = __webpack_public_path__ + "img/culture.1f3c0535.jpg";